import { Input } from "@/components/ui/Input";
import { InputShell } from "@/components/ui/InputShell";
import type { ReactNode } from "react";

// ─── Constants ──────────────────────────────────────────────

export const SCALE_MIN = 0.01;
export const SCALE_MAX = 100;
export const POS_MIN = -1000;
export const POS_MAX = 1000;

// ─── Helpers ────────────────────────────────────────────────

export function toDisplayName(objectId: string): string {
  return objectId
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function clampValue(
  value: number,
  min: number,
  max: number,
  fixed = 2,
): string {
  const clamped = Math.max(min, Math.min(max, value));
  return clamped.toFixed(fixed);
}

// ─── Shared UI Components ───────────────────────────────────

export function LabeledRow({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <div className="flex items-center gap-2 mb-3">
      <label className="text-[10px] font-medium text-sands-500 uppercase tracking-wider w-14 shrink-0">
        {label}
      </label>
      <div className="flex-1 min-w-0">{children}</div>
    </div>
  );
}

export function AxisInput({
  axis,
  value,
  onChange,
  step = "0.1",
  min,
  max,
}: {
  axis: string;
  value: string;
  onChange: (v: string) => void;
  step?: string;
  min?: number;
  max?: number;
}) {
  return (
    <InputShell>
      <span className="text-xs text-sands-400 font-medium">{axis}</span>
      <Input
        type="number"
        step={step}
        min={min}
        max={max}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        accent="none"
        surface="ghost"
        borderWeight="none"
        inputSize="xs"
        className="flex-1 min-w-0 text-sm pl-1 pr-0.5 py-0.5"
      />
    </InputShell>
  );
}
